export const listPromptsConfig = () => ({
  url: `/v2/prompts`,
});

export const getPromptConfig = (promptId) => ({
  url: `/v2/prompts/${promptId}`,
});

export const createPromptConfig = () => ({
  url: `/v2/prompts`,
});

export const updatePromptConfig = (promptId) => ({
  url: `/v2/prompts/${promptId}`,
});

export const deletePromptConfig = (promptId) => ({
  url: `/v2/prompts/${promptId}`,
});

export const listLlmsConfig = () => ({
  url: `/v2/llms`,
});

export const listPromptScreensConfig = () => ({
  url: `/v2/prompts_screen`,
});

export const createPromptScreenConfig = () => ({
  url: `/v2/prompts_screen`,
});

export const updatePromptScreenConfig = (promptScreenId) => ({
  url: `/v2/prompts_screen/${promptScreenId}`,
});
